/** Tenant SPA theme toggle (header / fixed placement on public and auth pages). */
import { LITERAL_STR } from './literal-atoms.js';
export const TENANT_THEME_TOGGLE_UI = Object.freeze({
    switchToLight: 'Switch to light mode',
    switchToDark: 'Switch to dark mode',
});
export const TENANT_THEME_MODE = Object.freeze({
    LIGHT: 'light',
    DARK: 'dark',
    SYSTEM: 'system',
});
export const TENANT_NAV_STYLE = Object.freeze({
    SIDEBAR: 'sidebar',
    TOPBAR: 'topbar',
});
export const TENANT_INTERFACE_THEME_DEFAULTS = Object.freeze({
    brandColor: '#0f1729',
    accentColor: '#0ea5e9',
    themeMode: TENANT_THEME_MODE.LIGHT,
    navStyle: TENANT_NAV_STYLE.SIDEBAR,
});
export const TENANT_INTERFACE_THEME_BRAND_COLORS = Object.freeze([
    { name: LITERAL_STR.NAVY, value: '#0f1729' },
    { name: LITERAL_STR.BLUE, value: '#3b82f6' },
    { name: 'Purple', value: '#8b5cf6' },
    { name: LITERAL_STR.GREEN, value: LITERAL_STR.X_10B981 },
    { name: LITERAL_STR.ROSE, value: '#f43f5e' },
    { name: LITERAL_STR.AMBER, value: LITERAL_STR.F59E0B },
]);
export const TENANT_INTERFACE_THEME_ACCENT_COLORS = Object.freeze([
    { name: LITERAL_STR.SKY, value: '#0ea5e9' },
    { name: 'Indigo', value: '#6366f1' },
    { name: 'Emerald', value: LITERAL_STR.X_059669 },
    { name: 'Orange', value: '#f97316' },
    { name: 'Pink', value: '#ec4899' },
]);
export const TENANT_INTERFACE_THEME_UI = Object.freeze({
    pageTitle: 'Theme Settings',
    pageSubtitle: 'Customize the appearance of your admin portal',
    breadcrumbLabel: 'Interface & Theme',
    themeModeTitle: 'Theme Mode',
    themeModeDescription: 'Choose between light, dark, or system preference',
    lightModeLabel: 'Light Mode',
    darkModeLabel: 'Dark Mode',
    systemModeLabel: 'System Default',
    brandColorTitle: 'Brand Color',
    brandColorDescription: 'Primary color used across buttons, links and highlights',
    primaryColorLabel: 'Primary Color',
    accentColorLabel: 'Accent Color',
    navigationTitle: 'Navigation Style',
    navigationDescription: 'Choose how the main navigation is displayed',
    sidebarNavLabel: 'Sidebar',
    sidebarNavDescription: 'Fixed side panel navigation',
    topbarNavLabel: 'Top Bar',
    topbarNavDescription: 'Horizontal navigation bar',
    saveButton: LITERAL_STR.SAVE_CHANGES,
    resetButton: 'Reset to Default',
    previewTitle: 'Live Preview',
    previewDescription: 'Updates as you change settings',
    savedToast: 'Theme preferences saved!',
    resetToast: 'Reset to default settings',
});
